import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger, } from '@cargomatic/ui';
export function ViewOptions({ columns, onToggleColumn, size = 'default', }) {
    return (React.createElement(DropdownMenu, null,
        React.createElement(DropdownMenuTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: size, className: "ml-auto hidden lg:flex" },
                React.createElement(SlidersHorizontal, { className: "mr-2 h-4 w-4" }),
                "View")),
        React.createElement(DropdownMenuContent, { align: "end" },
            React.createElement(DropdownMenuLabel, null, "Toggle columns"),
            React.createElement(DropdownMenuSeparator, null),
            columns.map((col) => (React.createElement(DropdownMenuCheckboxItem, { key: col.id, className: "capitalize", checked: col.visible, onCheckedChange: (value) => onToggleColumn(col.id, !!value), onSelect: (e) => e.preventDefault() }, col.label))))));
}
